import { Actions } from '../actions/permissions'
import { ActionsState } from '../../models/permissions'

let defaultState: ActionsState = {
    actions: [],
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case Actions.GET_ACTIONS_REQUEST:
            return {
                ...state,
            }
        case Actions.GET_ACTIONS_SUCCESS:
            return {
                ...state,
                actions: action.actions,
            }
        case Actions.GET_ACTIONS_FAILURE:
            return {
                ...state,
            }
        default:
            return state
    }
}
